import React, { useMemo, useState } from 'react'
import {
  Button,
  Stack, Typography
} from '@mui/material'
import { useTranslation } from 'react-i18next'
import { FormProvider, useForm } from 'react-hook-form'
import { useMutation, gql } from '@apollo/client'

import { toast } from 'components/global/CUK/Toast/Toast'
import { deserializeErrors } from 'apollo-client'

import { CATEGORIES_ROLES } from '../../roles-mapping'
import CategorySection from './components/CategorySection/CategorySection'
import { useIdsSelected } from '../../store'

import { useCategories } from '../../Edit/Panels/Roles'

const OPERATION_SYNCHRONIZE = gql`
  mutation synchronizeContacts($sf_ids: [ID]!, $roles: Roles!) {
    result: synchronizeContacts(sf_ids: $sf_ids, roles: $roles) {
      status
    }
  }
`

const Categories = () => {
  const categories = useCategories()
  return (
    <>
      <CategorySection
        mode="edit"
        category={categories.find(({ name }) => name === 'projects')}
        isInternal={false}
        withBorder={false}
        compact={true}
        colorScheme={'blue'}
      />
      <CategorySection
        mode="edit"
        category={categories.find(({ name }) => name === 'supervision')}
        isInternal={false}
        withBorder={false}
        compact={true}
        colorScheme={'blue'}
      />
      <CategorySection
        mode="edit"
        category={categories.find(({ name }) => name === 'wifi')}
        isInternal={false}
        withBorder={false}
        compact={true}
        colorScheme={'blue'}
      />
      <CategorySection
        mode="edit"
        category={categories.find(({ name }) => name === 'codes')}
        isInternal={false}
        withBorder={false}
        compact={true}
        colorScheme={'blue'}
      />
      <CategorySection
        mode="edit"
        category={categories.find(({ name }) => name === 'stream_cast')}
        isInternal={false}
        withBorder={false}
        compact={true}
        colorScheme={'blue'}
      />
      <CategorySection
        mode="edit"
        category={categories.find(({ name }) => name === 'documents')}
        isInternal={false}
        withBorder={false}
        compact={true}
        colorScheme={'blue'}
      />
    </>
  )
}
const Synchronize = () => {
  const [idsSelected, setIdsSelected] = useIdsSelected()
  const [error, setError] = useState<string>()
  const {t} = useTranslation()
  const defaultRoles = CATEGORIES_ROLES.flatMap(({roles}) => roles)
    .reduce((acc, cur) => ({...acc, ...cur}), {})
  const methods = useForm({
    defaultValues: {
      roles: {
        ...defaultRoles,
        center_beta: true
      }
    },
    mode: 'onBlur',
    reValidateMode: 'onBlur'
  })
  const [synchronize, {loading}] = useMutation(OPERATION_SYNCHRONIZE)
  const errorMessage = useMemo(() => {
    if (!error) {
      return null
    }
    const [, code ] = error?.split('::') || []
    if (code) {
      return t(`errors.contact.${code}`)
    } else {
      return t('errors.contact.unknown')
    }
  },[error])

  const handleSubmit = async () => {
    const {roles} = methods.getValues()
    try {
      await synchronize({variables: {sf_ids: idsSelected, roles}}) as {error: string}
      toast.success(t('auth.card_in_mass.sync.modal.body', '', {duration: 7000}))
      // @ts-expect-error to fix
      setIdsSelected([])
    } catch (e) {
      // @ts-expect-error to fix
      setError(deserializeErrors(e))
    }
  }

  return (
    <FormProvider {...methods}>
      {
        Boolean(errorMessage) && (
          <Typography variant={'caption'} color={'error'}>{errorMessage}</Typography>
        )
      }
      <Stack justifyContent="space-between" sx={{ height: '100%', minHeight: 0 }}>
        <Stack
          gap={2}
          sx={{
            overflowY: 'auto',
            flex: 1,
            minHeight: 0,
            scrollbarWidth: 'none',
            px: 1,
            py: 1,
            '&::-webkit-scrollbar': {
              display: 'none'
            }
          }}
        >
          <Categories />
        </Stack>
        <Stack alignSelf="end" flexShrink={0} mt={4}>
          <Button
            disabled={loading}
            variant={'contained'}
            size={'small'}
            onClick={handleSubmit}
          >
            {t('auth.card_in_mass.button_sync')}
          </Button>
        </Stack>
      </Stack>
    </FormProvider>
  )
}

export default Synchronize